// assets
import { SettingFilled } from '@ant-design/icons';

const icons = {
  SettingFilled
};

const menuItems = {
  id: 'site-setting',
  title: 'Hệ thống',
  type: 'group',
  roles: ['admin'],
  children: [
    {
      id: 'setting',
      title: 'Cài đặt',
      type: 'item',
      url: '/setting',
      icon: icons.SettingFilled,
      target: false,
      visible: true,
      roles: ['admin']
    }
  ]
};

export default menuItems;
